import React from 'react';

function Page_not_found() {
    return (
        <div className='h-[100vh] flex justify-center mt-[50px] sm:mt-0 md:mt-0 lg:mt-0 items-start sm:items-center md:items-center lg:items-center text-[25px] sm:text-[30px] md:text-[40px] lg:text-[50px] text-white'>404 | Page not found</div>
    )
}

export default Page_not_found;